module.exports = __webpack_public_path__ + "img/login-img.5f50b347.png";